import FeatureGates from '@/services/FeatureGates';

const selfiePreviewFeatureKey = 'enable_selfie_preview';
const enableGradientAttributeBar = 'enable_gradient_attribute_bar';
const enableHighlightedUndoRedo = 'enable_highlighted_undo_redo';
const enableSkinToneSwatch = 'enable_skin_tone_swatch';
const shareOutfitCTAOptionFeatureKey = 'share_outfit_cta_option';
const enableCuratedClosetFeatureKey = 'enable_curated_closet';
const showSnapchatUpsellBannerFeatureKey = 'show_snapchat_upsell_banner';
const showAppDeprecationBannerFeatureKey = 'show_app_deprecation_banner';

let featureGating: Record<string, boolean | number> = {};

const setFeatureGating = (features: Record<string, boolean>) => {
  if (features) {
    // "featureGating is an object" is our invariant e.g. we do not want it to be undefined
    featureGating = features;
  }
};

const isSelfiePreviewEnabled = () => {
  return featureGating[selfiePreviewFeatureKey] === true;
};

const arePromosEnabled = (): boolean => {
  // Automatically enable outside of prod, use gating otherwise
  return BUILD_FLAGS.ENVIRONMENT !== 'production' ? true : FeatureGates.promosEnabledInProduction;
};

const useAssetsService = (): boolean => {
  return BUILD_FLAGS.ENVIRONMENT !== 'production'
    ? true
    : FeatureGates.useAssetsServiceInProduction;
};

const isUpdatedTraitNavEnabled = (): boolean => {
  return Boolean(featureGating[enableGradientAttributeBar]);
};

const isHighlightedUndoRedoEnabled = (): boolean => {
  return Boolean(featureGating[enableHighlightedUndoRedo]);
};

const shareOutfitCTAOption = (): number => {
  return Number(featureGating[shareOutfitCTAOptionFeatureKey] || 0);
};

const isSkinToneSwatchEnabled = (): boolean => {
  return false;
  // Temporarily disabled to mitigate production issue on Snapchat iOS 11.72 - 11.74 builds.
  // return featureGating[enableSkinToneSwatch];
};

const isCuratedClosetEnabled = (): boolean => {
  return featureGating[enableCuratedClosetFeatureKey] === 1;
};

const isSnapchatUpsellBannerEnabled = (): boolean => {
  return featureGating[showSnapchatUpsellBannerFeatureKey] === true;
};

const isAppDeprecationBannerEnabled = (): boolean => {
  return featureGating[showAppDeprecationBannerFeatureKey] === true;
};

export default {
  featureGating,
  setFeatureGating,
  isSelfiePreviewEnabled,
  arePromosEnabled,
  isUpdatedTraitNavEnabled,
  useAssetsService,
  isHighlightedUndoRedoEnabled,
  isSkinToneSwatchEnabled,
  shareOutfitCTAOption,
  isCuratedClosetEnabled,
  isSnapchatUpsellBannerEnabled,
  isAppDeprecationBannerEnabled,
};
